module.exports = __webpack_public_path__ + "static/media/no_search_result.1a654222.svg";